import { Component } from '@angular/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html'
})
export class HeaderComponent {

}


// WEBPACK FOOTER //
// ./src/app/header/header.component.ts